import { get } from 'lodash';

import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function setCatQuizResult({ commit }, { quizResult, pageId }) {
  commit(types.SET_QUIZ_RESULT, { quizResult, pageId });

  return Promise.resolve(quizResult);
}

export function setCatQuizResults({ commit }, { quizResults }) {
  commit(types.SET_QUIZ_RESULTS, { quizResults });

  return Promise.resolve(quizResults);
}

export function setCatQuizRewardType({ commit }, { rewardType }) {
  return commit(types.SET_CAT_QUIZ_REWARD_TYPE, { rewardType });
}

export function saveCatQuizResult({ dispatch }, { data, catId, pageId }) {
  return http.post(`${MINERVA_API_URL}/cats/${catId}/quizzes`, data)
    .then((res) => {
      dispatch('setCatQuizRewardType', { rewardType: get(res.headers, 'x-ct-reward-type', '') });
      return dispatch('setCatQuizResult', { quizResult: res.data, pageId });
    })
    .catch(err => Promise.reject(err));
}

export function fetchCatQuizResults({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/cat_quiz_results`, { params })
    .then(res => dispatch('setCatQuizResults', { quizResults: res.data }));
}
